/* @flow @format */

import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';

import { ButtonIcon, Footer, Page, PageContainer } from '@sonyged/ext-proc';

import type { Contest } from '../../redux/reducer/entities';
import type { ContestType, StoreState } from '../../redux/types';
import { makeT, themeOf } from './utils';
import { selectAllMissionCoursesForContest } from '../../redux/selector';
import AppContext from '../../AppContext';
import LoadingButton from '../../components/LoadingButton';

type OwnProps = {|
  kind: ContestType,
  contest: Contest,
  fieldTitle: string,
|};

type Props = {
  ...OwnProps,
  missionCourses: any[],
};

const dict = {
  _: {
    missionLabel: 'こんかいの ミッション',
  },
  sushi: {
    missionLabel: '今回のミッション',
  },
  'ice-a': {
    missionLabel: '今回のミッション',
  },
  'sushi-a': {
    missionLabel: '今回のミッション',
  },
  'pizza-a': {
    missionLabel: '今回のミッション',
  },
};
const t = makeT(dict);

class IndexPage extends React.Component<Props> {
  static contextType = AppContext;

  componentDidMount() {
    this.context.soundController.bgmPlay('proc_chat_top01_home_re2', true);
  }

  render() {
    const { missionCourses, kind, fieldTitle } = this.props;
    return (
      <div className={`proc-${kind}-index-page theme-index-page-template tertiary100-bg-color ${themeOf(kind)}`}>
        <Page.normal menu={false} fullHeight={false} className="flex1">
          <PageContainer.normal>
            <img className="theme-image" src={`../images/pages/top/img_theme_${kind}@3x.png`} />

            {missionCourses.map(missionCourse => (
              <Link
                key={missionCourse.uid}
                to={`/${kind}/courses${missionCourse.isDefault ? '' : `/${missionCourse.uid}`}`}
                className={'course-container'}
              >
                <div className={'title-container'}>
                  <div className={'sub-title proc-small-font secondary100-color'}>{t(kind, 'missionLabel')}</div>
                  <div className={'title proc-medium-font gray100-color'}>
                    {missionCourse.courseContents[0].bookInfo.title}
                  </div>
                </div>
                <img className="image" src={`../images/pages/${kind}/img_${kind}_course@2x.png`} />
              </Link>
            ))}

            <Link to={`/${kind}/fields`} className={'course-container'}>
              <div className={'title-container'}>
                <div className={'sub-title proc-small-font secondary100-color'}>フィールド</div>
                <div className={'title proc-medium-font gray100-color'}>{fieldTitle}</div>
              </div>
              <img className="image" src={`../images/pages/${kind}/img_${kind}_field@2x.png`} />
            </Link>
          </PageContainer.normal>
        </Page.normal>

        <Footer.nav
          shadow={false}
          navItem={
            <Link to={'/'}>
              <LoadingButton.light>
                <ButtonIcon.back />
              </LoadingButton.light>
            </Link>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState, ownProps: OwnProps) => {
  const missionCourses = selectAllMissionCoursesForContest(state, ownProps.contest);
  return { missionCourses };
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(IndexPage);
